"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  route: {
    dashboard: "首页",
    documentation: "文档",
    guide: "引导页",
    rolePermission: "角色权限",
    pagePermission: "页面权限",
    icons: "图标",
    components: "组件",
    tinymce: "富文本编辑器",
    markdown: "Markdown",
    jsonEditor: "JSON 编辑器",
    dndList: "列表拖拽",
    splitPane: "Splitpane",
    avatarUpload: "头像上传",
    dropzone: "Dropzone",
    sticky: "Sticky",
    countTo: "Count To",
    componentMixin: "小组件",
    backToTop: "返回顶部",
    dragDialog: "拖拽 Dialog",
    dragSelect: "拖拽 Select",
    dragKanban: "可拖拽看板",
    charts: "图表",
    keyboardChart: "键盘图表",
    lineChart: "折线图",
    mixChart: "混合图表",
    example: "综合实例",
    nested: "路由嵌套",
    menu1: "菜单1",
    menu2: "菜单 2",
    Table: "Table",
    dynamicTable: "动态 Table",
    dragTable: "拖拽 Table",
    inlineEditTable: "Table 内编辑",
    complexTable: "综合 Table",
    tab: "Tab",
    form: "表单",
    createArticle: "创建文章",
    editArticle: "编辑文章",
    articleList: "文章列表",
    errorPages: "错误页面",
    page401: "401",
    page404: "404",
    errorLog: "错误日志",
    excel: "Excel",
    exportExcel: "导出 Excel",
    selectExcel: "导出 已选择项",
    mergeHeader: "导出 多级表头",
    uploadExcel: "上传 Excel",
    zip: "Zip",
    pdf: "PDF",
    exportZip: "Export Zip",
    theme: "换肤",
    clipboardDemo: "Clipboard",
    i18n: "国际化",
    externalLink: "外链",
    profile: "个人中心",
    Privileges: "权限",
    Basic: "基础",
    UserList: "用户列表",
    GradeList: "等级管理",
    Notice: "公告管理",
    upgradeStrategyPage: "升级攻略",
    activityOne: "活动管理",
    OrganRoles: "组织角色",
    OrganManagement: "组织管理",
    RoleManagement: "角色管理",
    ResManagement: "资源管理",
    DeptStaff: "部门员工",
    authOrg: "员工角色",
    SysManagement: "系统管理",
    SchManagement: "调度管理",
    ArcConfiguration: "归档配置",
    system: "系统",
    Logs: "日志",
    changePassword: "修改密码",
    my: "我的",
    UserAccount: "用户账号",
    OrgUsers: "组织用户",
    Language: "语言配置"
  },
  navbar: {
    dashboard: "首页",
    changePassword: "修改密码",
    logOut: "退出登录",
    profile: "个人中心",
    theme: "换肤",
    size: "布局大小"
  },
  login: {
    title: "商品数据分析平台",
    logIn: "登录",
    username: "账号",
    password: "密码",
    any: "随便填"
  },
  documentation: {
    documentation: "文档",
    github: "Github 地址"
  },
  permission: {
    addRole: "新增角色",
    editPermission: "编辑权限",
    roles: "你的权限",
    switchRoles: "切换权限",
    tips: "在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。",
    delete: "删除",
    confirm: "确定",
    cancel: "取消"
  },
  guide: {
    description: "引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于",
    button: "打开引导"
  },
  components: {
    documentation: "文档",
    tinymceTips: "富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见",
    dropzoneTips: "由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone",
    stickyTips: "当页面滚动到预设的位置会吸附在顶部",
    backToTopTips1: "页面滚动到指定位置会在右下角出现返回顶部按钮",
    backToTopTips2: "可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素",
    imageUploadTips: "由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。"
  },
  table: {
    dynamicTips1: "固定表头, 按照表头顺序排序",
    dynamicTips2: "不固定表头, 按照点击顺序排序",
    dragTips1: "默认顺序",
    dragTips2: "拖拽后顺序",
    title: "标题",
    importance: "重要性",
    type: "类型",
    remark: "点评",
    search: "搜索",
    add: "添加",
    export: "导出",
    reviewer: "审核人",
    id: "序号",
    date: "时间",
    author: "作者",
    readings: "阅读数",
    status: "状态",
    actions: "操作",
    edit: "编辑",
    publish: "发布",
    draft: "草稿",
    delete: "删除",
    cancel: "取 消",
    confirm: "确 定"
  },
  example: {
    warning: "创建和编辑页面是不能被 keep-alive 缓存的，因为keep-alive 的 include 目前不支持根据路由来缓存，所以目前都是基于 component name 来进行缓存的。如果你想类似的实现缓存效果，可以使用 localStorage 等浏览器缓存方案。或者不要使用 keep-alive 的 include，直接缓存所有页面。详情见"
  },
  errorLog: {
    tips: "请点击右上角bug小图标",
    description: "现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。",
    documentation: "文档介绍"
  },
  excel: {
    export: "导出",
    selectedExport: "导出已选择项",
    placeholder: "请输入文件名(默认excel-list)"
  },
  zip: {
    export: "导出",
    placeholder: "请输入文件名(默认file)"
  },
  pdf: {
    tips: "这里使用   window.print() 来实现下载pdf的功能"
  },
  theme: {
    change: "换肤",
    documentation: "换肤文档",
    tips: "Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。"
  },
  tagsView: {
    refresh: "刷新",
    close: "关闭",
    closeOthers: "关闭其它",
    closeAll: "关闭所有"
  },
  settings: {
    title: "系统布局配置",
    theme: "主题色",
    tagsView: "开启 Tags-View",
    fixedHeader: "固定 Header",
    sidebarLogo: "侧边栏 Logo"
  },
  // 菜单
  menu: {
    ListPowerStations: "电站列表",
    DataAcquisition: "数据采集",
    PowerStationStatusStatistics: "电站状态统计",
    EquipmentStatusStatistics: "设备状态统计"
  },
  // 按钮
  buttons: {
    Search: "搜索",
    Add: "新建",
    Edit: "编辑",
    Details: "详情",
    Delete: "删除",
    Cancel: "取 消",
    Confirm: "确 定",
    Binding: "绑定",
    Unbind: "解除绑定",
    Login: "登录",
    RepairFault: "故障处理",
    NewUser: "新增客户",
    Reassignment: "重新分配",
    Disable: "禁用",
    grantAuth: "授权",
    Close: "关闭",
    ViewResources: "查看资源",
    update: "更新",
    add: "添加"
  },
  tableFrom: {
    sources: "资源",
    Welcome: "欢迎访问",
    ProID: "产品ID",
    proKey: "序列号",
    ProName: "产品名称",
    DeviceName: "设备名称",
    DeviceId: "设备ID",
    sn: "序列号",
    mac: "mac",
    ProType: "产品类型",
    ComMode: "通讯方式",
    Operation: "操作",
    ConPparameters: "配置参数",
    ParameterName: "参数名",
    Unit: "单位",
    Ratio: "比例",
    NamePoStation: "电站名称",
    PowerStationOverview: "电站概览",
    SerialNumEqu: "设备序列号",
    DataTime: "数据时间",
    DataIden: "数据标识",
    DataValue: "数据值",
    EquDescription: "设备描述",
    VersionData: "版本数据",
    EquipmentNo: "设备编号",
    Devicemac: "设备mac",
    OperationStatus: "运行状态",
    Normal: "正常",
    Failure: "故障",
    PowerStation: "所属电站",
    PowerStationInformation: "电站信息",
    ElectricityGenerationToday: "今日发电量",
    ElectricityGenerationMonth: "本月发电量",
    CumulativePowerGeneration: "累计发电量",
    CurrentPower: "当前功率",
    CreationTime: "创建时间",
    CreationUser: "创建人",
    CustomerID: "客户编号",
    CusNickname: "客户昵称",
    conInformation: "联系方式",
    address: "地址",
    mailbox: "邮箱",
    AutTime: "授权时间",
    nickname: "昵称",
    energyManagement: "能源管理",
    Telephone: "电话",
    DefaultAccount: "默认账户",
    LoginAccount: "登录账户",
    AccountPassword: "账户密码",
    SerialNumber: "序号",
    PowerStationName: "电站名称",
    BeUserID: "归属用户ID",
    runState: "运行状态",
    OnlineState: "在线状态",
    PoStationAddr: "电站地址",
    InCapacity: "装机容量",
    syncDate: "并网日期",
    ReServiceProviders: "重新分配服务商",
    ServiceProviderName: "服务商名称",
    ServiceProviderAddress: "服务商地址",
    ServiceproviderType: "服务商类型",
    EditCustomer: "编辑客户",
    CustomerDetails: "客户详情",
    MySupplier: "我的供应商",
    Myagent: "我的代理商(服务商)",
    contacts: "联系人",
    contactNum: "联系电话",
    ServiceType: "服务类型",
    ServiceArea: "服务区域",
    ContractNum: "合同编号",
    ContractStatus: "合同状态",
    QuCertification: "资质认证",
    NumProjects: "项目数",
    LastMainDate: "最后维护日期",
    remarks: "备注",
    SetPartners: "设置合作伙伴",
    name: "名称",
    identification: "标识",
    OrgaType: "组织类型",
    userName: "用户名",
    password: "密码",
    DetailedAddr: "详细地址",
    role: "角色",
    UserID: "用户ID",
    state: "状态",
    mobilePhone: "手机",
    logonName: "登录名称",
    LoginPassword: "登录密码",
    Email: "电子邮箱",
    UserMobile: "用户手机",
    UserNickname: "用户昵称",
    AssigRoles: "分配角色",
    filingRate: "归档频率",
    storageMedium: "存储介质",
    filingTime: "最后归档时间",
    OrgGrouping: "组织分组",
    GroupName: "分组名称",
    SubgroupCode: "分组编码",
    UpdateTime: "更新时间",
    UpdateUser: "更新人",
    Level: "级别",
    Type: "类型",
    ConfigInfo: "配置信息",
    ValidityPeriod: "规则",
    secretKey: "秘钥",
    superAdmin: "超级管理员",
    User: "用户",
    LegalPerson: "法人",
    microsoft: "微信",
    Domain: "域",
    ReDays: "保留天数",
    SelectDate: "选择日期",
    SelectTime: "选择时间",
    Numcustomers: "客户数",
    NumEuipment: "设备数",
    MonGeneration: "月发电",
    YearGeneration: "年发电",
    run: "运行",
    Stop: "停止",
    Unknown: "未知状态",
    Online: "在线",
    Offline: "离线",
    Inactive: "未激活",
    Language: '语言',
    Abbreviation: '简称'
  },
  placeholder: {
    pleSelect: "请选择",
    pleEnterNameType: "请输入产品名称、产品类型查询",
    pleProID: "请输入产品ID",
    pleSn: "请输入设备sn码",
    pleDeviceName: "请输入设备名称",
    pleSerNumber: "请输入序列号",
    pleProName: "请输入产品名称",
    pleProType: "请输入产品类型",
    pleCommMode: "请选择通讯方式",
    PleaseProduct: "请选择产品",
    PleaseParNameSearch: "请输入参数名查询",
    PleaseUserName: "请输入用户名",
    PleasePassword: "请输入密码",
    SelectStartTime: "选择开始时间",
    SelectEndTime: "选择结束时间",
    To: "至",
    PleaseCusNameEmail: "请输入客户名称/邮箱",
    PleaseLoginUser: "请输入登录用户",
    PleaseUserPassword: "请输入用户密码",
    PleaseCorrectEmai: "请输入正确邮箱格式",
    PleaseSerProQuery: "请输入服务商名称查询",
    PleaseSerProvider: "请选择服务商",
    PleaseNameSeProQuery: "请输入【服务商名称、联系人】查询",
    ServiceType: "服务类型",
    PleaseMoreDigits: "请输入大于6位数密码",
    PleaseProvince: "请选择省份",
    PleaseCity: "请选择城市",
    PleaseRegion: "请选择地区",
    PleaseFillName: "请填写名称",
    PleaseFillIdent: "请填写标识",
    PleaseSelectType: "请选择类型",
    PleasKey: "请输入密钥",
    PleaseFillUsername: "请填写用户名",
    PleaseFillPassword: "请填写密码",
    OrganName: "组织名",
    OrgSearchHoldPlace: "请输入组织【名称、标识】查询",
    PleasePhoneNumber: "请输入用户名|手机号|姓名",
    AlphanumericCharacter: "字母数字横线,字母数字开头",
    PleaseCoEmailAddr: "请输入正确的邮箱地址",
    PleaseStorageMedium: "请输入存储介质",
    PleaseFreFiling: "请选择归档频率",
    PleaseConfigParameters: "请输入配置参数",
    PleaseParameterName: "请输入参数名",
    PleaseNameLogo: "请输入【名称、标识】查询",
    RoleGroupNameIdent: "角色组名称|标识",
    PleaseOrgType: "请选择组织类型",
    Please130AlChinese: "请填写名称 1-30字母数字中文",
    Please160AlpCode: "请填写Code,1-60 字母数字",
    PleaseLanguage: '请输入语言',
    PleaseLangAbbr: '请输入语言简称'
  },
  prompts: {
    prompts: "提示",
    operationDel: "此操作将永久删除该文件, 是否继续?",
    DeletedSuc: "删除成功",
    DeletionCan: "已取消删除",
    SaveSuc: "保存成功",
    UnProContinue: "此操作将解除绑定, 是否继续?",
    UnCancelled: "已取消解绑",
    UnSuccessful: "解绑成功",
    WhetherReDevice: "是否修复该设备",
    RepairSuccessful: "修复成功",
    Repaircancelled: "已取消修复",
    ReServiceProvider: "确定重新分配服务商吗?",
    Unallocated: "已取消分配",
    success: "成功",
    SuccUpdate: "更新成功",
    CreatedSucc: "创建成功",
    wantDelRecord: "是否删除该记录?",
    wantDisableUser: "是否禁用该用户?",
    DisSucc: "禁用成功",
    wantEnableUser: "是否启用该用户?",
    SucEnabled: "启用成功",
    Cancelled: "已取消",
    minutes: "分钟",
    hours: "小时",
    Days: "天"
  }
};